import { Injectable } from '@angular/core';
import { BaseCrudService } from '../../../core/data/services/base-crud.service';
import HealthInsured from '../../../core/data/models/health.insured.model';

@Injectable()
export class HealthInsuredService extends BaseCrudService<HealthInsured> {
  controller = 'HealthInsured';
  getMyHealthInsured(idNumber: string) {
    return this.get<HealthInsured[]>({ idNumber });
  }
}
